import { type Commit } from "vuex";
import axios, { type AxiosRequestConfig } from "axios";
import { useMercureSubscription } from "@/composables/useMercureSubscription";
import { t } from "@/lib/i18n";

export const useSubscribeForFile = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getters: any,
  commit: Commit,
  usingRootGetters: boolean = false,
) {
  const subscribeForFile = async (
    reportKey: string,
    requestConfig: AxiosRequestConfig,
    print = false,
  ) => {
    const storeRoot = usingRootGetters ? `reports/` : "";

    if (getters[`${storeRoot}isLoadingKey`](reportKey)) {
      return;
    }
    commit(`${storeRoot}startedLoadingReport`, reportKey, { root: usingRootGetters });

    let res;

    try {
      res = await axios(requestConfig);
    } catch (error) {
      commit(`${storeRoot}finishedLoadingReport`, reportKey, { root: usingRootGetters });

      throw error;
    }

    const { subscribeFromResponse } = useMercureSubscription();

    subscribeFromResponse(res, print)
      .catch(() => {
        commit(
          "notifications/showNotification",
          {
            type: "error",
            text: t(
              "For some reason we couldn't generate your report. Please try again later or change filtering criteria.",
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        commit(`${storeRoot}finishedLoadingReport`, reportKey, { root: usingRootGetters });
      });
  };

  return { subscribeForFile };
};
